module.exports = __webpack_public_path__ + "static/media/bio-big.c7febd83.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners-hover/bio-big.png
// module id = 2907
// module chunks = 1